/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Dictionary_unknown_ } from './Dictionary_unknown_';
/**
 * Make all properties in T optional
 */
export type Partial_CatalogProductImportItem_ = {
    /**
     * Optional product name for creation or name-based matching
     */
    name?: string;
    /**
     * Optional product ID for update operations
     */
    id?: number;
    /**
     * Optional external identifier for idempotent upserts
     */
    sourceId?: string;
    /**
     * Product description
     */
    description?: string | null;
    /**
     * Currency code for the price (defaults to CLP if omitted)
     */
    currency?: Partial_CatalogProductImportItem_.currency | null;
    /**
     * Optional reference to the analysis configuration
     */
    analysisConfigId?: number | null;
    /**
     * Optional custom fields for the product
     */
    customFields?: Dictionary_unknown_;
    /**
     * External URL referencing the product
     */
    sourceUrl?: string | null;
    /**
     * Optional canonical price in the provided currency
     */
    price?: string | null;
};
export namespace Partial_CatalogProductImportItem_ {
    /**
     * Currency code for the price (defaults to CLP if omitted)
     */
    export enum currency {
        CLP = 'CLP',
        UF = 'UF',
    }
}

